import TextWithEllipsis from '@/components/TextWithEllipsis';
import { LuAlignLeft } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import RowV2 from '@/components/v2/RowV2';
import LogEntry from '@/screens/workflows/workflowLogs/LogEntry';
import { useVirtualizer } from '@tanstack/react-virtual';

const LOG_ENTRY_HEIGHT = 34;

const VirtualizedWorkflowLogEntries = ({ logs, logId, scrollRef, onSummaryClick }) => {
  const virtualizer = useVirtualizer({
    count: logs.length + 1,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => LOG_ENTRY_HEIGHT,
    getItemKey: (index) => (index === 0 ? 'summary' : `log-${logs[index - 1]?.id || index}`),
    overscan: 5
  });
  const virtualItems = virtualizer.getVirtualItems();
  const lastItem = virtualItems[virtualItems.length - 1];
  const paddingTop = virtualItems[0]?.start || 0;
  const paddingBottom = lastItem ? virtualizer.getTotalSize() - lastItem.end : 0;

  return (
    <div style={{ paddingTop, paddingBottom }}>
      {virtualItems.map((item) =>
        item.index === 0 ? (
          <RowV2 key={item.key} className="log-entry" onClick={onSummaryClick} active={logId === 'summary'}>
            <RowV2.Left>
              <div className="status-container">
                <IconV2 icon={LuAlignLeft} size={8} className="light-medium" />
                <TextWithEllipsis className="entry-message">
                  <span>Logs Summary</span>
                </TextWithEllipsis>
              </div>
            </RowV2.Left>
          </RowV2>
        ) : (
          <LogEntry key={item.key} log={logs[item.index - 1]} />
        )
      )}
    </div>
  );
};

export default VirtualizedWorkflowLogEntries;
